import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useAppSelector } from "../../store/store";
import { Link } from "react-router-dom";
type Props = {
  item: any
  index: any
  open: any
  handleDrawerSwipeClose?: () => void
};
const SidebarItem = ({ item, index, open, handleDrawerSwipeClose }: Props) => {
  const { userData } = useAppSelector((state) => state.authReducer);
  const { palette, themeMode } = useAppSelector((state: any) => state.themeSlice);
  return (
    <Link
      key={index}
      onClick={handleDrawerSwipeClose}
      to={item.to}
      style={{
        textDecoration: "none"
      }}
    >
      <ListItem
        disablePadding
        sx={{
          display: "block",
          my: 1,
          // borderRadius: "25px 25px 25px 25px",
          background:
            item.to === window.location.pathname ||
              (item.to === '/dashboard' && window.location.pathname === '/' && userData.group !== 'admin') ||
              (item.to === '/ops-dashboard' && window.location.pathname === '/')
              ? palette.primary
              : "",
          // height: "40px",
        }}
      >
        <ListItemButton
          disableRipple
          sx={{
            minHeight: 40,
            // borderRadius: "25px 25px 25px 25px",
            justifyContent: open ? "initial" : "center",
            p: 0,
            pl: open ? '14px' : '0px',
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              display: 'flex',
              mr: open ? 1 : "0px",
              justifyContent: "center",
              color:
                item.to === window.location.pathname ||
                  (item.to === '/dashboard' && window.location.pathname === '/' && userData.group !== 'admin') ||
                  (item.to === '/ops-dashboard' && window.location.pathname === '/')
                  ? "#fff"
                  : themeMode === "dark"
                    ? "#fff"
                    : "",
            }}
          >
            {item.icon}
          </ListItemIcon>
          {open && <ListItemText
            primary={(userData.group !== 'admin' && userData.group !== 'tenantAdmin') && item.label === 'Threshold Management' ? "Threshold Information" : item.label}
            sx={{
              paddingRight: '0.4rem',
              whiteSpace: 'normal',
              textDecoration: "none",
              opacity: open ? 1 : 0,
              color:
                item.to === window.location.pathname ||
                  (item.to === '/dashboard' && window.location.pathname === '/' && userData.group !== 'admin') ||
                  (item.to === '/ops-dashboard' && window.location.pathname === '/')
                  ? "#fff"
                  : themeMode === "dark"
                    ? "#fff"
                    : "#4e4e4e",
            }}
            primaryTypographyProps={{
              fontSize:"13px",
              fontFamily: "'Plus Jakarta Sans', sans-serif", // Ensure it applies
            }}
          />}
        </ListItemButton>
      </ListItem>
    </Link>
  )
}

export default SidebarItem;